import appSignalRService from "./appSignalRService";

/**
 * 监听通话已应答
 * @param {function} callBack 回调函数
 */
export function onAnswered(callBack) {
    appSignalRService.on('answered', callBack);
}

/**
 * 取消监听通话已应答
 * @param {function} callBack 回调函数
 */
export function offAnswered(callBack) {
    appSignalRService.off('answered', callBack);
}

/**
 * 监听通话已挂断
 * @param {function} callBack 回调函数
 */
export function onHungup(callBack) {
    appSignalRService.on('hungup', callBack);
}

/**
 * 取消监听通话已挂断
 * @param {function} callBack 回调函数
 */
export function offHungup(callBack) {
    appSignalRService.off('hungup', callBack);
}

/**
 * 监听错误
 * @param {function} callBack 回调函数
 */
export function onError(callBack) {
    appSignalRService.on('error', callBack);
}

/**
 * 取消监听错误
 * @param {function} callBack 回调函数
 */
export function offError(callBack) {
    appSignalRService.off('error', callBack);
}

/**
 * 监听正在呼叫
 * @param {function} callBack 回调函数
 */
export function onTrying(callBack) {
    appSignalRService.on('trying', callBack);
}

/**
 * 取消监听正在呼叫
 * @param {function} callBack 回调函数
 */
export function offTrying(callBack) {
    appSignalRService.off('trying', callBack);
}

/**
 * 监听对方响铃
 * @param {function} callBack 回调函数
 */
export function onRinging(callBack) {
    appSignalRService.on('ringing', callBack);
}

/**
 * 取消监听对方响铃
 * @param {function} callBack 回调函数
 */
export function offRinging(callBack) {
    appSignalRService.off('ringing', callBack);
}

/**
 * 发起呼叫
 * @param {string} phoneNum 电话号码
 * @returns {Promise}
 */
export function call(phoneNum) {
    return appSignalRService.send('call', phoneNum);
}

/**
 * 挂断通话
 * @returns {Promise}
 */
export function hungup() {
    return appSignalRService.send('hungup');
}
